module.exports = __webpack_public_path__ + "img/BatteryCarInfoBggreen.2890f639.png";